<template>
  <v-dialog
    v-model="planDialog"
    width="500px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span v-if="type==0||type==4">Void Quote</span>
          <span v-if="type==1">Refund</span>
          <span v-if="type==3">Adjust Policy</span>
          <i
            class="el-icon-close"
            @click="planDialog=false"></i>
        </div>
      </div>
      <div class="dialog-body">
        <div class="flex-content">
          <p
            v-if="type==0||type==1"
            class="tip">This quote is paid. It will be refunded to these payment methods.</p>
          <p
            v-if="type==3"
            class="tip">The adjustment difference must be refunded. It will be refunded to these
            payment methods.</p>
          <p
            v-if="type==4"
            class="tip">This policy is paid. It will be refunded to these payment methods.</p>
          <!--          <p class="tip void-color">Part of this refund failed. You can try again or choose another method for-->
          <!--            the remaining amount</p>-->
          <div class="flex-box">
            <template v-if="type==4">
              <div
                class="flex-info">
                <span>Policy Premium</span>
                <span >{{ mobilePremium|formatMoney(2,true) }}</span>
              </div>
              <!--              <div  class="flex-info">-->
              <!--                <span>Admin Charge </span>-->
              <!--                <span>-->
              <!--                  <v-input-->
              <!--                    v-model.number="formData.handling_fee"-->
              <!--                    prepend="+$"-->
              <!--                    :keyFloatNumber="true"-->
              <!--                    maxlength="8"-->
              <!--                    :min="0"-->
              <!--                    @blur="handlerComputed"></v-input>-->
              <!--                </span>-->
              <!--              </div>-->
              <div
                class="flex-info total-amount">
                <span>Refund Amount</span>
                <span class="amount">{{ mobilePremium|formatMoney(2,true) }}</span>
              </div>
            </template>
            <div
              class="flex-info ">
              <span >
                <v-select
                  v-model="selected"
                  :list="getSelected.refund_type"></v-select>
                <p
                  v-if="getSelected.credit_after_90==1"
                  class="flex void-color">
                  <font-awesome-icon
                    icon="exclamation-triangle"
                  />
                  <span>Can't refund to credit card after 90 days</span>
                </p>
              </span>
              <span>{{getSelected.premium}}</span>
            </div>
            <template v-if="type==4">
              <div
                class="flex-info">
                <span>Hold Dollars</span>
                <span >{{ mobilePremium|formatMoney(2,true) }}</span>
              </div>
            </template>
            <template v-if="type!=4">
              <div
                v-for="(item,index) in data"
                :key="index"
              >
                <div
                  v-if="item.name!='Total'&&item.field_name!='refund_type'"
                  class="flex-info ">
                  <span>{{item.name}}</span>
                  <span>{{item.premium}}</span>
                </div>
              </div>
              <div
                class="flex-info total-amount">
                <span>Total Payable</span>
                <span class="amount">{{ getTotal.premium }}</span>
              </div>
            </template>
          </div>
        </div>
        <div
          v-if="(selected==4||selected==5||selected==6)&&type!=4"
          class="flex-content">
          <span class="title-span">{{selectName}} Info</span>
          <p
            class="tip">For record keeping purposes,please finish {{selectName.toLowerCase()}} refund before continuing.</p>
          <div class="flex-box padding">
            <div
              class="form-item ">
              <span>Reference No.</span>
              <v-input v-model="reference_no"></v-input>
            </div>
            <div
              class="form-item ">
              <span>Remarks</span>
              <v-input
                v-model="remark"
                type="textarea"
                :rows="4"></v-input>
            </div>
          </div>
        </div>
      </div>
      <div class="flex footer-button">
        <v-button @click="planDialog=false">Cancel</v-button>
        <v-button
          type="success"
          @click="ConfirmCoupon">Next</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {setQuoteVoid, setRefundCal, voidPolicyOrder} from '@/api/order'

export default {
  name: 'CouponDialog',
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId:{
      type:[String,Number,Array]
    },
    type:{
      type:[String,Number],
      default:0,//4 手机
    },
    refund:{
      type:[String,Number],
      default:''
    },
    isNormal:{
      type:Boolean,
      default:true
    },
    buyData:{
      type:Array,
      default:()=>([])
    },
  },
  data() {
    return {
      planDialog: false,
      data:[],
      selected:'',
      refund_data:'',
      reference_no:'',
      remark:'',
      formData:{
        handling_fee:0
      }
    }
  },
  computed:{
    getTotal() {
      if(this.data.length<=0) {
        return {}
      }
      let total = this.data.filter(item => item.name=='Total')
      return  total[0]||{}
    },
    getSelected(){
      if(this.data.length<=0) {
        return {}
      }
      let total = this.data.filter(item => item.field_name=='refund_type')
      let {refund_type} = total[0]
      refund_type.forEach(item=>{
        if(item.selected==1)
          this.selected=item.id
      })
      return  total[0]||{}
    },
    selectName(){
      let arr = this.getSelected.refund_type||[]
      let result = ''
      arr.some(item=>{
        if(item.id==this.selected)
          result = item.name
      })
      return result
    },
    mobilePremium(){
      let data = this.buyData.filter(item=>item.name=='paid')||[]
      return data.length>0?data[0].premium:0
    }
  },
  watch:{
    refund:{
      immediate:true,
      handler(val){
        this.refund_data = val
      }
    }
  },
  methods: {
    handlerComputed(){

    },
    changeDialog(data) {
      if(this.isNormal){
        this.network().setQuoteVoid()
      }else{
        this.refund_data = data
        if(this.type==4){
          this.refund_data = this.mobilePremium
        }
        this.network().setRefundCal()
      }
    },
    ConfirmCoupon() {
      this.planDialog = false
      let params = {
        refund_type: this.selected,
        reference_no: this.reference_no,
        remark: this.remark
      }
      if (this.isNormal) {
        this.network().voidPolicyOrder(params)
      } else
      {
        this.$emit('setVoid', params)
      }
    },
    getOptionName(id){

      let result = ''
      this.getSelected.refund_type.some(item => {
        if (item.id == id) {
          result = item.name
          return true
        }
        return false
      })
      return result
    },
    network() {
      return {
        setQuoteVoid: async () => {
          const { data } = await setQuoteVoid({
            order_id: this.orderId
          })
          this.data = data
          this.planDialog = !this.planDialog
        },
        setRefundCal:async ()=>{
          const { data } = await setRefundCal({
            order_id: this.orderId,
            refund:this.refund_data,
            // type:this.type
          })
          this.data = data
          this.planDialog = !this.planDialog
        },
        voidPolicyOrder: async (params) => {
          const { data } = await voidPolicyOrder({
            order_id: this.orderId,
            ...params
          })
          this.$NewMessageBox({
            title: 'Void Quote',
            message: 'This policy has been voided.',
            confirmBtn:'Done',
            btnType:'success'
          }).then(
            this.$emit('setVoid',data.data)
          )
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .title-span{
    color: #24292E;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .dialog-body{
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;
  }
  .footer-button{
    padding: 15px;
    justify-content: space-between;
  }
  .tip{
    color: #586069;
    font-weight: 500;
  }
  .flex-content {
    //width: 280px;
    .padding{
      padding: 10px;
    }
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      //width: 280px;
      margin: 16px 0;

      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #E1E4E8;

        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight: 500;
        }

        span:last-child {
          color: #24292E;
          font-size: 14px;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
      .void-color{
        color: #CB2431;
        align-items: center;
        margin-top: 5px;
        span{
          color: #CB2431!important;
          margin-left: 5px;
        }
      }
    }
    .coupon-button{
      .el-button{
        width: 100%;
      }
      .margin-right{
        margin-right: 10px;
      }
    }
    .coupon-data{
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 1px solid #D1D5DA;
      border-radius: 5px;
      padding: 16px;
      .coupon-title{
        color: #24292E;
        font-size: 16px;
        font-weight: 600;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .coupon-des{
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        font-size: 12px;
        margin-top: 8px;
        -webkit-box-orient: vertical;
        color: #586069;
      }
    }
  }
}
</style>
